import { render, staticRenderFns } from "./goodsBaseInfo.vue?vue&type=template&id=4b3ccb9b&scoped=true&"
import script from "./goodsBaseInfo.vue?vue&type=script&lang=js&"
export * from "./goodsBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsBaseInfo.vue?vue&type=style&index=0&id=4b3ccb9b&scoped=true&lang=scss&"
import style1 from "./goodsBaseInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ccb9b",
  null
  
)

component.options.__file = "goodsBaseInfo.vue"
export default component.exports